// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const complianceKeys = {
  all: ['compliance'] as const,
  formPrefill: (projectId: string) =>
    [...complianceKeys.all, projectId] as const,
};

export default complianceKeys;
